import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import LinkBox from '../../../components/common/header/LinkBox';
import * as authApi from '../../../lib/api/auth';
import { HEADER_LINKS_CHANGED } from '../../../lib/headerLinks';

const LinkBoxContainer = () => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const filterObject = {
          blcCd: 'BASE',
          mlcCd: 'HEADER',
          slcCd: 'LINKS',
          useYn: 'Y',
        };
        const response = await authApi.getBaseCode(filterObject);

        if (active) {
          // step 이 문자열이라 그냥 정렬하면 10 이 2 보다 앞에 온다.
          const orderedList = _.orderBy(response.data.list, (item) => Number(item.step || 0));
          setLinks(orderedList);
        }
      } catch (err) {
        console.log(err);
      }
    };

    load();

    // 공통코드 화면에서 바로가기를 고치면 새로고침 없이 바로 반영한다.
    window.addEventListener(HEADER_LINKS_CHANGED, load);

    return () => {
      active = false;
      window.removeEventListener(HEADER_LINKS_CHANGED, load);
    };
  }, []);

  return <LinkBox links={links} />;
};

export default LinkBoxContainer;
